import ID from '@compassdigital/id';
import { DateTime } from 'luxon';
import {
  TenderTypes,
  type ConfigTender,
  type DbTender,
  type Tender,
  MealplanTypes,
  MealplanTypeToProvider,
} from '@centric-os/types';

/**
 * Maps mealplan tender form state to a tender payload for the public and private mealplan configs.
 * @param {Partial<Tender>} tender - The tender form state.
 * @returns {ConfigTender} The mapped tender payload.
 */
export const mapTenderPayload = (
  tender: Partial<Tender>,
  mealplanType: MealplanTypes,
): ConfigTender => {
  const payload = {
    id: tender.id,
    tender_number: ID('mealplan', MealplanTypeToProvider[mealplanType], 'tender', tender.id),
    type: tender.type,
    name: tender.name,
  };

  switch (tender.type) {
    case TenderTypes.DECLINING_BALANCE: {
      const supportsSplitTender = [
        MealplanTypes.ATRIUM,
        MealplanTypes.ATRIUM_SSO,
        MealplanTypes.TRANSACT_BLACKBOARD,
        MealplanTypes.TRANSACT_BLACKBOARD_SAAS,
      ].includes(mealplanType);
      const base: ConfigTender = {
        ...payload,
        tax_exempt: tender.tax_exempt,
      };
      if (supportsSplitTender) {
        const stipend = (tender as Partial<DbTender>).stipend_split === true;
        return stipend ? { ...base, stipend_split: true } : base;
      }
      return base;
    }
    case TenderTypes.MEAL_EQUIVALENT:
      return {
        ...payload,
        tax_exempt: tender.tax_exempt,
        max_swipes_per_transaction: tender.max_swipes_per_transaction,
        rates: tender.rates?.map((rate) => ({
          amount: rate.amount * 100,
          hours: `${DateTime.fromJSDate(rate.startTime).toFormat('HH:mm')}-${DateTime.fromJSDate(
            rate.endTime,
          ).toFormat('HH:mm')}`,
        })),
      };
    case TenderTypes.MEAL_EXCHANGE:
      return {
        ...payload,
        tax_exempt: true, // meal exchange is always tax exempt
      };
    default:
      console.error('Invalid tender type');
  }
};
